import { render, staticRenderFns } from "./SiteEnrolment.vue?vue&type=template&id=c2fc72bc"
import script from "./SiteEnrolment.vue?vue&type=script&lang=ts"
export * from "./SiteEnrolment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports